import type { ReactNode } from "react";
import type { Theme, FontPairing } from "@structurify/shared-types";

interface Props {
  children: ReactNode;
  theme: Theme;
  fonts: FontPairing;
}

export function KeyHint({ children, theme, fonts }: Props) {
  return (
    <kbd
      style={{
        fontFamily: fonts.mono,
        fontSize: 10,
        padding: "2px 5px",
        border: `1px solid ${theme.rule}`,
        borderBottomWidth: 2,
        borderRadius: 3,
        color: theme.inkSoft,
        background: theme.surface,
        minWidth: 16,
        display: "inline-block",
        textAlign: "center",
        lineHeight: 1.1,
      }}
    >
      {children}
    </kbd>
  );
}
